import React from 'react'

import { PlusCircle as PlusCircleIcon } from 'react-feather'
import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'

import { Container, ContentHeader, Page, Permitted } from 'components'

import { NcTable } from './components'

import constants from 'constants/index'
import { routes } from 'Routes'

const NcMain = () => {
  const history = useHistory()

  const redirectToCreate = () => history.push(routes.nc.new)

  return (
    <Page title="Não Conformidades (NCs)">
      <Container maxWidth={false}>
        <ContentHeader title="Não Conformidades (NCs)">
          <Permitted
            tag={constants.permissions.MONITORING_MANAGEMENT_NC.MANAGE}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={redirectToCreate}
              fullWidth
            >
              Criar
            </Button>
          </Permitted>
        </ContentHeader>
        <NcTable />
      </Container>
    </Page>
  )
}

export default NcMain
